import ServiceCRUD from '../../../../../../services/ServiceExportFLEXCHAT';

class unifiedExportService extends ServiceCRUD {
  constructor() {
    super('relatorio');
  }
}

export default new unifiedExportService();
